import { FormSection, Link, List, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function OsasvV1FollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen OSAS verwijzing">
            <Timeline>
                <Timeline.Item>De patiënt ontvangt direct instructies en uitleg via e-mail</Timeline.Item>
                <Timeline.Item>
                    <Timeline.ItemHeading>De patiënt doet slaaponderzoek thuis</Timeline.ItemHeading>
                    Slaaprecorder wordt binnen 1 week thuisbezorgd (past door de brievenbus)
                </Timeline.Item>
                <Timeline.Item>
                    <Timeline.ItemHeading>
                        De patiënt heeft een videoconsult met de Ksyos KNO- of longarts
                    </Timeline.ItemHeading>
                    <List
                        size="small"
                        styleType="bullet"
                    >
                        <List.Item>Binnen twee weken nadat de patiënt het slaaponderzoek heeft afgerond</List.Item>
                        <List.Item>De specialist bespreekt de eventuele diagnose tijdens het consult</List.Item>
                        <List.Item>De patiënt en specialist bepalen en bespreken samen de behandeling</List.Item>
                    </List>
                </Timeline.Item>
                <Timeline.Item>
                    Je ontvangt de uitslag in het Ksyos platform en via Edifact in je HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
                <Timeline.Item>
                    <Timeline.ItemHeading>Eén van deze opties volgt</Timeline.ItemHeading>
                    <List
                        size="small"
                        styleType="bullet"
                    >
                        <List.Item>
                            Ksyos biedt de patiënt een passende behandeling (CPAP, MRA, SPT) en begeleiding. Jij hoeft
                            niks te doen
                        </List.Item>
                        <List.Item>Ksyos verwijst naar andere 2e-lijns zorg. Jij hoeft niks te doen</List.Item>
                        <List.Item>Geen slaapapneu? Ksyos geeft advies</List.Item>
                    </List>
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
